import * as React from 'react';
import { ContentPanel } from '@enginuity-apps-ui-components/atoms/content-panel/content-panel';
import PaperPlaneSVG from './images/PaperPlane';
import CircularTickSVG from './images/CircularTick';
import { Button } from '@enginuity-apps-ui-components/atoms/button/button';
import "./styles.scss";

export type IChangeCompleteProps = {
  // email?: string;
};

export const ChangeComplete: React.FunctionComponent<IChangeCompleteProps> = ({ children }) => {
  return (
    <div className="container  ">
      <div className="row md-spacer-80 spacer-32">
        <div className="col-lg-8 offset-lg-2">
          <ContentPanel>
            <div className="message-panel__padding">
              <div className="row spacer-32">
                <div className="col-12">
                  <div className="circular-tick">{CircularTickSVG}</div>
                </div>
              </div>
              <div className="row spacer-32">
                <div className="col-12">
                  {children}
                </div>
              </div>
            </div>
          </ContentPanel>
        </div>
      </div>
    </div >
  );
}

export default ChangeComplete;
